import React from 'react';

export const pageMeta = {
  "name": "JS Number Reference",
  "link": "/javascript/numbers/reference"
};

export default function JavascriptNumbersReference() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">JS Number Reference</h2>
      <p>Route: /javascript/numbers/reference</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
